var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBcbc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#004ab5",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.483 7.793a8.755 8.755 0 1010.75 12.427l-7.662-4.235L18.68 7.8a8.755 8.755 0 00-6.196-.007zm.546 1.573a7.089 7.089 0 015.018.006l-2.517 6.627 6.204 3.43a7.089 7.089 0 11-8.705-10.063zm2.936-4.386c1.191.047 2.366.287 3.48.71L15.53 15.999l9.651 5.335A11.028 11.028 0 1115.965 4.98zm7.529 3.812c.264 0 .51.031.736.095.666.183 1.116.597 1.35 1.241.143.391.174.775.094 1.152-.072.374-.245.71-.519 1.01.514-.023.963.092 1.35.342.383.242.666.613.847 1.111.257.706.18 1.351-.233 1.935-.408.574-1.137 1.053-2.188 1.435l-4.164 1.516-2.931-8.053 3.934-1.432c.644-.234 1.219-.352 1.724-.352zm-.61 1.666c-.24 0-.517.058-.833.173l-1.852.674.69 1.899 1.853-.675c.46-.167.78-.374.958-.622.18-.248.212-.529.097-.843-.114-.314-.318-.505-.612-.572a1.221 1.221 0 00-.301-.034zm1.562 3.122c-.252.003-.548.066-.888.19l-2.174.791.724 1.99 2.174-.791c.49-.179.83-.393 1.016-.644.195-.253.23-.548.108-.886-.16-.437-.48-.654-.96-.65z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcbc);
export default __webpack_public_path__ + "static/media/bcbc.6335b921d5c8f609df89ce6a9fc19bd4.svg";
export { ForwardRef as ReactComponent };